module.exports = __webpack_public_path__ + "img/sxf.7bc08d9c.jpg";